/**
 * Pages already rebuilt in the new Olli design.
 *
 * Every other page is an old page shown inside the new frame: it is wrapped
 * in `.olli-legacy`, which keeps the design's styles off it so it looks
 * exactly as before. When a page is converted, add its route here (a path, or
 * a pattern with `:param` segments) and it renders as a design page.
 */
export const CONVERTED_ROUTES = [
  "/marketing/dashboard", // Marketing → Dashboard
  "/analytics/page-performance", // Marketing → Page Performance
  "/ads/campaigns", // Marketing → Ad Campaigns (list)
  "/ads/campaigns/new", // Marketing → Ad Campaigns (create)
  "/ads/campaigns/:id", // Marketing → Ad Campaigns (one campaign)
  "/ads/lead-forms", // Marketing → Lead Forms
  "/ads/audiences", // Marketing → Audiences
  "/ads/rules", // Marketing → Optimization Rules
  "/content/compose", // Marketing → Compose Post
  "/content/comments", // Marketing → Comments
  "/social-inbox", // Marketing → Social Inbox
  "/automations", // Marketing → Automations
  "/instagram", // Marketing → Instagram
  "/research/competitors", // Marketing → Competitor Research
  "/dashboard", // Dashboard → Home
  "/wallet", // Wallet
  "/wallet/transactions", // Wallet → History
  "/wallet/pricing", // Wallet → Rates by country
  "/subscription/manage", // My subscription
  "/settings/integrations/meta-conversions/guide", // Settings → Meta Conversions guide
  "/crm/leads", // CRM
  "/crm/leads/reports", // CRM
  "/crm/leads/new", // CRM
  "/crm/leads/edit/:id", // CRM
  "/crm/leads/:id", // CRM
  "/crm/contacts", // CRM
  "/crm/contacts/new", // CRM
  "/crm/contacts/edit/:id", // CRM
  "/crm/contacts/:id", // CRM
  "/crm/tasks", // CRM
  "/crm/settings/scoring-rules", // CRM
  "/crm/settings/assignment-rules", // CRM
  "/crm/settings/tags", // CRM
  "/appointments", // Appointments & Schedules
  "/appointments/new", // Appointments & Schedules
  "/appointments/:id", // Appointments & Schedules
  "/schedules", // Appointments & Schedules
  "/patients", // Patients & Treatment Plans
  "/patients/new", // Patients & Treatment Plans
  "/patients/edit/:id", // Patients & Treatment Plans
  "/patients/:id", // Patients & Treatment Plans
  "/treatment-plans", // Patients & Treatment Plans
  "/treatment-plans/new", // Patients & Treatment Plans
  "/treatment-plans/:id", // Patients & Treatment Plans
  "/settings/treatments", // Patients & Treatment Plans
  "/settings/treatment-statuses", // Patients & Treatment Plans
  "/settings/instruction-templates", // Patients & Treatment Plans
  "/settings/instruction-templates/new", // Patients & Treatment Plans
  "/settings/instruction-templates/edit/:id", // Patients & Treatment Plans
  "/support/dashboard", // Support
  "/support/complaints", // Support
  "/support/complaints/:id", // Support
  "/support/feedback", // Support
  "/subscription/plans", // Plans and pricing
  "/ask-olli", // Ask Olli & Notifications
  "/notifications", // Ask Olli & Notifications
  "/settings/ai-agent", // AI Agents
  "/settings/ai-agent/templates", // AI Agents
  "/knowledge-base", // AI Agents
  "/waba", // WhatsApp
  "/waba/conversations", // WhatsApp
  "/waba/conversations/:id", // WhatsApp
  "/waba/templates", // WhatsApp
  "/waba/templates/new", // WhatsApp
  "/waba/templates/:id/view", // WhatsApp
  "/waba/templates/:id/edit", // WhatsApp
  "/waba/campaigns", // WhatsApp
  "/waba/campaigns/new", // WhatsApp
  "/waba/campaigns/:id", // WhatsApp
  "/waba/campaigns/:id/edit", // WhatsApp
  "/waba/api-docs", // WhatsApp
  "/waba/settings", // WhatsApp
  "/settings/branding", // Settings
  "/settings/facilities", // Settings
  "/settings/facilities/new", // Settings
  "/settings/facilities/edit/:id", // Settings
  "/settings/departments", // Settings
  "/settings/staff", // Settings
  "/settings/staff/new", // Settings
  "/settings/staff/edit/:id", // Settings
  "/settings/specialties", // Settings
  "/settings/lead-statuses", // Settings
  "/settings/integrations", // Settings
  "/settings/integrations/api-keys", // Settings
  "/settings/integrations/api-docs", // Settings
  "/settings/integrations/:id", // Settings
  "/settings/integrations/:id/connect-meta", // Settings
  "/settings/integrations/:id/connect-google", // Settings
  "/settings/integrations/:id/connect-whatsapp", // Settings
  "/settings/integrations/:id/webhook-setup", // Settings
  "/settings/integrations/:id/logs", // Settings
];

// Paths that match a pattern above but are not converted yet (still old pages).
const NOT_YET = [];

const toRegExp = (route) => new RegExp(`^${route.replace(/:[^/]+/g, "[^/]+")}/?$`);
const patterns = CONVERTED_ROUTES.map(toRegExp);

export const isConverted = (pathname) => !NOT_YET.includes(pathname.replace(/\/$/, "")) && patterns.some((re) => re.test(pathname));
